import { isTestEnv, isProdEnv, isDevEnv } from '@agritask/js-utils/libs/env';
import { AtToast } from '@agritask/vue-components';
import { GlobalStaticLabelFlag } from '@agritask/vue-components/hooks';
import { addSentryPlugin } from './plugins/sentry';
/**
 * Doing common setup for Vue apps
 * @param {App} app
 * @param {boolean} initRootSentry Initializes the root instance for Sentry,
 * should be done only once for the entire FE
 */
export function initSetup(app, initRootSentry) {
    if (!isTestEnv() && !isDevEnv()) {
        addSentryPlugin(app, initRootSentry);
    }
    app.use(AtToast, {
        topInset: 'calc(var(--spacing-08) + (var(--header-height)))',
        bottomInset: 'var(--spacing-08)',
        inlineInset: 'var(--spacing-08)',
    });
    app.provide(GlobalStaticLabelFlag, true);
    app.config.performance = !isProdEnv();
}
